import React from 'react';

function SectionContainer({
    children,
    backgroundColor = 'bg-gray-50',
    customWidth = 'w-full',
    borderColor = 'border-gray-100',
}) {
    return (
        <div className={`rounded-lg p-3 sm:p-5 ${backgroundColor} ${customWidth} border ${borderColor} shadow-sm`}>
            {children}
        </div>
    );
}
export default SectionContainer;
